$(function() {
  $('img').each(function(index, el) {
    $(el).one('load', function() {
      $(el).css('background', 'none')
    }).trigger('load')
  })
})